import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { SunMark } from "../components/Logo";
import { api } from "../lib/api";
import { useLang } from "../i18n";

const Shell = ({ children }) => (
  <div className="min-h-screen bg-[#0B0A08] text-[#F7F4EE] flex items-center justify-center px-6">
    <div className="max-w-lg w-full text-center">
      <SunMark className="w-20 h-auto mx-auto mb-10" />
      {children}
    </div>
  </div>
);

export function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data?.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(r.data?.payment_status)) { setState("error"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("error");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <Shell>
      {state === "checking" && <p className="flex items-center justify-center gap-3 text-[#E6C594]" data-testid="payment-checking"><Loader2 className="animate-spin" /> {t.pay.checking}</p>}
      {state === "paid" && (
        <div data-testid="payment-success">
          <CheckCircle2 className="mx-auto text-[#D4AF37]" size={40} />
          <h1 className="mt-6 font-display text-4xl sm:text-5xl">{t.pay.successTitle}</h1>
          <p className="mt-4 text-[#CFC6B6]">{t.pay.successText}</p>
        </div>
      )}
      {state === "error" && (
        <div data-testid="payment-error">
          <XCircle className="mx-auto text-red-300" size={40} />
          <p className="mt-6 text-[#CFC6B6]">{t.pay.error}</p>
        </div>
      )}
      <Link to="/" className="btn-gold mt-10" data-testid="payment-back-home">{t.pay.back}</Link>
    </Shell>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  return (
    <Shell>
      <div data-testid="payment-cancel">
        <h1 className="font-display text-4xl sm:text-5xl">{t.pay.cancelTitle}</h1>
        <p className="mt-4 text-[#CFC6B6]">{t.pay.cancelText}</p>
      </div>
      <Link to="/" className="btn-gold mt-10" data-testid="payment-back-home">{t.pay.back}</Link>
    </Shell>
  );
}
